import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';

import { ClassToggleService, HeaderComponent, INavData } from '@coreui/angular';
import { Subscription, filter } from 'rxjs';

import { environment } from 'src/environments/environment';

import { AuthApiService, InactiveCheckService, PromptUpdateService } from 'src/app/core/services';

export interface DropdownMenuActions {
  label: string;
  action: () => void;
  icon?: string;
}

@Component({
  selector: 'app-base-layout-header',
  templateUrl: './base-layout-header.component.html',
})
export class BaseLayoutHeaderComponent extends HeaderComponent implements OnInit, OnDestroy {

  @Input() sidebarId: string = "sidebar";
  @Input() headerNavItems: INavData[] = [];
  @Input() dropdownMenuActions: DropdownMenuActions[] = [];
  @Input() userName: string;
  @Input() tmLogout = 0;

  private inactiveCheck: Subscription;

  protected appVersion: string;

  protected updater: PromptUpdateService;
  protected authService: AuthApiService;
  protected inactiveCheckService: InactiveCheckService;

  public backgroundTitleCls: string | null = null;

  constructor(private classToggler: ClassToggleService, protected injector: Injector,) {
    super();

    this.appVersion = environment.version;
  }

  ngOnInit(): void {
    this.authService = this.injector.get(AuthApiService);
    this.inactiveCheckService = this.injector.get(InactiveCheckService);
    this.updater = this.injector.get(PromptUpdateService);

    if (!environment.production) {
      this.backgroundTitleCls = 'debug-alert-header-color';
    } else if (environment.prefix.endsWith('-qa')) {
      this.backgroundTitleCls = 'qa-alert-header-color';
    }

    this.startInactiveCheck();
  }

  ngOnDestroy(): void {
    if (this.inactiveCheck) {
      this.inactiveCheck.unsubscribe();
    }
  }

  private startInactiveCheck(): void {
      if (this.tmLogout > 0) {
        this.inactiveCheck = this.inactiveCheckService.event().pipe(
          // tap(console.log),
          filter(time => this.tmLogout !== 0 && time > this.tmLogout))
          .subscribe(time => {
            this.logout();
          });
        this.inactiveCheckService.start();
      }
    }

  logout(): void {
    this.authService.logout()
      .subscribe(() => {
        // this.router.navigate(['/login']);
      });
  }

  checkForUpdate(): void {
    this.updater.checkForUpdate();
  }

  applyUpdate(): void {
    if (confirm('Recarregar para atualizar agora?')) {
      this.updater.applyUpdate();
    }
  }
}
